import React from 'react';
import Header from '../../components/header';
import Footer from '../../components/footer';

const BoostingView = () => {
  return (
    <div className="bg-gray-900 text-white min-h-screen">
      <Header />
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="md:col-span-2">
            <div className="bg-gray-800 p-4 rounded-lg">
              <img src="https://via.placeholder.com/800x400" alt="Boosting Thumbnail" className="w-full h-auto rounded-lg" />
            </div>
            <div className="mt-8">
              <h2 className="text-2xl font-bold mb-4">Description</h2>
              <p className="text-gray-400">
                Our professional boosters will help you reach your desired rank quickly and efficiently. We offer a variety of boosting services to fit your needs.
              </p>
            </div>
          </div>
          <div>
            <div className="bg-gray-800 p-4 rounded-lg">
              <h1 className="text-3xl font-bold">Boosting Service</h1>
              <div className="text-yellow-400 text-2xl font-bold my-4">$49.99</div>
              <button className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded w-full">Purchase Boosting</button>
              <div className="mt-4 text-sm text-gray-400">ETA: 24 hours</div>
            </div>
            <div className="bg-gray-800 p-4 rounded-lg mt-4">
              <h2 className="text-xl font-bold mb-4">Booster Information</h2>
              <div className="flex items-center">
                <img src="https://via.placeholder.com/50" alt="Booster Avatar" className="w-12 h-12 rounded-full" />
                <div className="ml-4">
                  <div className="font-bold">BoosterName</div>
                  <div className="text-sm text-gray-400">Top Rated Booster</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BoostingView;